export const LEVEL_NAMES = {
  0: "Member",
  1: "Rising Star",
  2: "Promotor",
  3: "Senior Promotor",
  4: "Community Builder",
  5: "Leader",
  6: "Senior Leader",
  7: "Regional Leader",
  8: "National Leader",
  9: "Senior National Leader",
  10: "Supreme Leader"
};

export const getLevelName = (level) => {
  const numLevel = Number(level);
  if (isNaN(numLevel)) return "Member";
  return LEVEL_NAMES[numLevel] || "Member";
};
